import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "side-bar"
};
var _hoisted_2 = ["onMouseenter", "onMouseleave", "onClick"];
var _hoisted_3 = ["src"];
var _hoisted_4 = ["onClick"];
var _hoisted_5 = ["src"];
import { ref, inject, computed } from 'vue';
import { getStore } from '@/util/store';

/* 变量 */

export default {
  __name: 'SideBar',
  props: {
    // 侧边栏数据
    barList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 悬浮框数据
    hoverList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 悬浮框选中id
    hoverId: {
      type: [String, Number],
      default: ''
    }
  },
  emits: ['tabChange', 'hoverEnter', 'hoverLeave', 'hoverChange', 'hoverDelete'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /* 工具 */
    var props = __props;
    var emit = __emit;
    var discussInfo = inject('discussInfo');
    var hoverTimer = ref(null);
    var hoverShow = ref(false);

    /* 计算属性 */
    // 当前是否为创建者
    var isCreator = computed(function () {
      var _getStore, _discussInfo$value;
      var userId = (_getStore = getStore({
        name: 'userInfo'
      })) === null || _getStore === void 0 ? void 0 : _getStore.id;
      return userId === ((_discussInfo$value = discussInfo.value) === null || _discussInfo$value === void 0 ? void 0 : _discussInfo$value.creatorId);
    });

    // 侧边栏列表
    var barList = computed(function () {
      return isCreator.value ? props.barList : props.barList.filter(function (e) {
        return !e.creator;
      });
    });

    /* 事件 */
    // 点击
    var tabChange = function tabChange(item) {
      emit('tabChange', item);
    };

    // 鼠标移入
    var handleMouseEnter = function handleMouseEnter(item) {
      if (!item.hover) return;
      hoverTimer.value = setTimeout(function () {
        hoverShow.value = true;
        emit('hoverEnter', item);
      }, 500);
    };

    // 鼠标离开
    var handleMouseLeave = function handleMouseLeave(item) {
      if (!item.hover) return;
      clearTimeout(hoverTimer.value);
      hoverShow.value = false;
      emit('hoverLeave', item);
    };

    // 悬浮框点击切换
    var hoverChange = function hoverChange(tabItem, hoverItem) {
      emit('hoverChange', hoverItem);
    };

    // 悬浮框点击删除
    var hoverDelete = function hoverDelete(tabItem, hoverItem) {
      emit('hoverDelete', hoverItem);
    };
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(barList.value, function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "item",
          onMouseenter: function onMouseenter($event) {
            return handleMouseEnter(item);
          },
          onMouseleave: function onMouseleave($event) {
            return handleMouseLeave(item);
          },
          onClick: function onClick($event) {
            return tabChange(item);
          }
        }, [_createElementVNode("img", {
          src: item.icon,
          alt: ""
        }, null, 8, _hoisted_3), _createElementVNode("span", null, _toDisplayString(item.name), 1), _withDirectives(_createElementVNode("div", {
          class: "hover-list",
          onClick: _cache[0] || (_cache[0] = _withModifiers(function () {}, ["stop"]))
        }, [_renderSlot(_ctx.$slots, "hoverList", {}, function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.hoverList, function (e) {
            return _openBlock(), _createElementBlock("div", {
              key: e.id,
              class: _normalizeClass(["hover-item", {
                'hover-active': e.id === props.hoverId
              }]),
              onClick: _withModifiers(function ($event) {
                return hoverChange(item, e);
              }, ["stop"])
            }, [_createElementVNode("div", null, [e.icon ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "icon",
              src: e.icon,
              alt: ""
            }, null, 8, _hoisted_5)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(e.name), 1)]), isCreator.value ? _withDirectives((_openBlock(), _createBlock(_component_svg_icon, {
              key: 0,
              class: "delete",
              name: "delete",
              onClick: _withModifiers(function ($event) {
                return hoverDelete(item, e);
              }, ["stop"])
            }, null, 8, ["onClick"])), [[_vShow, e.id !== props.hoverId]]) : _createCommentVNode("", true), isCreator.value ? _withDirectives((_openBlock(), _createBlock(_component_svg_icon, {
              key: 1,
              class: "delete",
              name: "delete-blue",
              onClick: _withModifiers(function ($event) {
                return hoverDelete(item, e);
              }, ["stop"])
            }, null, 8, ["onClick"])), [[_vShow, e.id === props.hoverId]]) : _createCommentVNode("", true)], 10, _hoisted_4);
          }), 128))];
        })], 512), [[_vShow, hoverShow.value && item.hover]])], 40, _hoisted_2);
      }), 128))]);
    };
  }
};